import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Observable }     from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import {Battezzato} from '../beans/battezzato';


@Injectable()
export class BattezzatiService {


	private heroesUrl='api/battezzati';
	private headers = new Headers({'Content-Type': 'application/json'});


	constructor (private http:Http){}

	getBattezzati(): Promise<Battezzato[]> {
		return this.http.get(this.heroesUrl)
				.toPromise()
				.then(response=>response.json().data as Battezzato[])
				.catch(this.handleError);
	} 

	getBattezzato(id: number): Promise<Battezzato>{
		const url = `${this.heroesUrl}/${id}`;
		return this.http.get(url).toPromise().then(response=> response.json().data as Battezzato)
		.catch(this.handleError);
	}

	search(term: string): Observable<Battezzato[]> {
    return this.http
               .get(`api/battezzati/?name=${term}`)
               .map(response => response.json().data as Battezzato[]);
  }

private handleError(error: any){
	console.error('Error in libri app',error);
	return Promise.reject(error.message||error);
}



}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/services/battezzati.service.ts